module.exports = __webpack_public_path__ + "img/SCWEST LOGO.ecfdea89.jpg";